import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { formatEventTime } from "@notemeal/utils-date-time";
import classnames from "classnames";
const useStyles = makeStyles(({ palette: { greyscale } }) => ({
    mealItemContainer: {
        backgroundColor: greyscale[25],
        padding: 10,
        margin: 10,
    },
    denseMealItemContainer: {
        backgroundColor: greyscale[25],
        padding: 0,
        margin: 3,
        textAlign: "center",
    },
    denseSnackItemContainer: {
        backgroundColor: greyscale[25],
        padding: 0,
        margin: 3,
        textAlign: "center",
    },
    exportedMealItemContainer: {
        backgroundColor: greyscale[25],
        marginTop: `5px`,
        marginBottom: `5px`,
        padding: `5px`,
    },
    exportedSnackItemContainer: {
        backgroundColor: greyscale[25],
        marginTop: `5px`,
        marginBottom: `5px`,
        padding: `5px`,
    },
}));
export const MealItemContainer = ({ children, className, sx, style }) => {
    const classes = useStyles();
    return (_jsx(Paper, { sx: sx, className: classnames(classes.mealItemContainer, className), style: style, children: children }));
};
const DenseMealItemContainer = ({ children }) => {
    const classes = useStyles();
    return _jsx(Paper, { className: classes.denseMealItemContainer, children: children });
};
const DenseSnackItemContainer = ({ children }) => {
    const classes = useStyles();
    return _jsx(Paper, { className: classes.denseSnackItemContainer, children: children });
};
export const ExportedMealItemContainer = ({ children }) => {
    const classes = useStyles();
    return _jsx(Paper, { className: classes.exportedMealItemContainer, children: children });
};
export const ExportedSnackItemContainer = ({ children }) => {
    const classes = useStyles();
    return _jsx(Paper, { className: classes.exportedSnackItemContainer, children: children });
};
export const MealItem = ({ meal, className }) => {
    return (_jsx(MealItemContainer, { className: className, children: _jsxs(Typography, { align: "center", children: [meal.name, " (", formatEventTime(meal), ")"] }) }));
};
export const DenseMealItem = ({ meal }) => {
    return meal.type === "meal" ? (_jsx(DenseMealItemContainer, { children: _jsxs(Typography, { variant: "subtitle1", align: "center", children: [meal.name, " (", formatEventTime(meal), ")"] }) })) : (_jsx(DenseSnackItemContainer, { children: _jsxs(Typography, { variant: "subtitle1", align: "center", children: [meal.name, " (", formatEventTime(meal), ")"] }) }));
};
//# sourceMappingURL=index.js.map